import {debounce} from 'lodash'

(function () {
    const html = document.getElementsByTagName('html')[0]
    const resize = function () {
        const width = document.documentElement.offsetWidth > 750 ? 750 : document.documentElement.offsetWidth
        html.style.fontSize = width / 750 * 100 + 'px'
    }
    window.addEventListener('resize', debounce(resize, 100))
    resize();
})();